import React, { useEffect, useState } from 'react';
import { useNavigate, useParams } from 'react-router-dom';
import { createParticipants, getAsmtById, updateAsmtById } from '../../services/authService';
import { useAuth } from '../../context/AuthContext';
import { decodeId } from '../../utills/idUtils';
import getDateAfter14Days, { getDateAfter7Days } from '../../hooks/utils';

const Participants = () => {
    const { encodedId } = useParams();
    const id = decodeId(encodedId);
    const [submitting, setSubmitting] = useState(false);

    const { state } = useAuth();
    const { user } = state;
    const source_user_id = user?.user_id;
    const [error, setError] = useState('');
    const [invitation_note, setInvitationNote] = useState(' ');
    const [asmt, setAsmt] = useState(null);
    const [participants, setParticipants] = useState([
        { first_name: '', last_name: '', user_name: '', relationship: '' },
        { first_name: '', last_name: '', user_name: '', relationship: '' },
        { first_name: '', last_name: '', user_name: '', relationship: '' },
        { first_name: '', last_name: '', user_name: '', relationship: '' }
    ]);

    const [expected_completion_date, setDate] = useState(null)

    useEffect(() => {
        // Set the value for expected_completion_date to the date after 14 days
        const dateIn14Days = getDateAfter7Days();
        // console.log("dateIn14Days", dateIn14Days)
        setDate(dateIn14Days);
    }, []);

    useEffect(() => {

        const formatDateToIST = (dateString) => {
            if (!dateString) return null; // Handle null case

            // Create a Date object
            const date = new Date(dateString);

            // Adjust to IST (UTC +5:30)
            const localDate = new Date(date.getTime() + (330 * 60000)); // Add 330 minutes (5 hours 30 minutes)

            // Format the date to 'YYYY-MM-DD' format
            const formattedDate = localDate.toISOString().split("T")[0];

            // Return the formatted date
            return formattedDate;
        };

        const formattedDate = formatDateToIST(expected_completion_date);

        const fetchApi = async () => {
            const getAsmt = await getAsmtById(id);
            setAsmt(getAsmt);
            try {
                await updateAsmtById(id, { invitation_note, expected_completion_date: formattedDate });
            } catch (error) {
                console.error("Failed to update assessment:", error);
            }
        };

        const fetchgetAsmtApi = async () => {
            const getAsmt = await getAsmtById(id);
            setAsmt(getAsmt);
        };

        if (id && invitation_note) {
            fetchApi();
        }
        fetchgetAsmtApi();


    }, [invitation_note, id, expected_completion_date]);

    const navigate = useNavigate();

    const addParticipant = () => {
        if (participants.length < 12) {
            setParticipants([...participants, { first_name: '', last_name: '', user_name: '', relationship: '' }]);
            setError(''); // Clear error when a participant is successfully added
        }
    };

    const removeParticipant = (index) => {
        if (participants.length > 4) {
            const updatedParticipants = participants.filter((_, i) => i !== index);
            setParticipants(updatedParticipants);
        } else {
            setError('At least 4 participants are required.');
        }
    };

    const handleInputChange = (index, event) => {
        const { name, value } = event.target;
        const updatedParticipants = participants.map((participant, i) =>
            i === index ? { ...participant, [name]: value } : participant
        );
        //console.log("updated prt", updatedParticipants)
        setParticipants(updatedParticipants);
    };

    const handleSubmit = async () => {
        if (submitting) return;
        setSubmitting(true);

        let assessment_id = id;
        const validParticipants = participants.filter(participant =>
            participant.user_name.trim() !== '' &&
            participant.first_name.trim() !== '' &&
            participant.last_name.trim() !== '' &&
            participant.relationship.trim() !== ''
        );
        let emailSet = new Set();
        let uniqueEmail = true;
        // console.log("participants",participants);
        for (let participant of participants) {
            if (emailSet.has(participant.user_name)) {
                uniqueEmail = false;
                break;
            }
            emailSet.add(participant.user_name);
        }
        if (!uniqueEmail) {
            setError("Each user must have a unique email address.");
            setSubmitting(false);
            return;
        }
        // validParticipants.length < 4
        // console.log("valid",validParticipants)
        if (validParticipants.length !== participants.length) {
            // setError('At least 4 participants must have complete details.');
            setError('All participants must have complete details.');
            setSubmitting(false);
            return;
        }
        try {
            const response = await createParticipants(validParticipants, source_user_id, assessment_id, invitation_note);
            //console.log("response paric", response);
            if (response.status === 201 || response.status === 207) {
                navigate(`/self-asmt/${encodedId}`);
            }
        } catch (error) {
            setError(error.message);
        } finally {
            setSubmitting(false);
        }
    };

    return (
        <div className="lg:px-16">
            <h1 className="text-2xl font-bold text-center text-blue-600 mb-4">
                Invite a minimum of 4 and a maximum of 12 people
            </h1>
            {/* <p className="text-center text-blue-500 mb-6">Instructions Instructions Instructions Instructions...</p> */}

            <div className="text-center mb-6">
                <p className="mb-2">Enter target completion period. We suggest 2 weeks from now:</p>
                <div className="inline-block relative w-64">
                    {asmt && (
                        <select
                            required
                            key={asmt.assessment_id}
                            className="block appearance-none w-full bg-gray-200 border border-gray-200 text-gray-700 py-3 px-4 pr-8 rounded leading-tight focus:outline-none focus:bg-white focus:border-gray-500"
                            value={expected_completion_date} // Set default to third reminder date
                            onChange={(e) => setDate(e.target.value)} // Bind to a state or variable holding the selected date
                        >
                            <option value={new Date(asmt.first_reminder_date).toLocaleDateString('en-GB', { day: 'numeric', month: 'short', year: 'numeric' })}>
                                {new Date(asmt.first_reminder_date).toLocaleDateString('en-GB', { day: 'numeric', month: 'short', year: 'numeric' })}
                            </option>
                            <option value={new Date(asmt.second_reminder_date).toLocaleDateString('en-GB', { day: 'numeric', month: 'short', year: 'numeric' })}>
                                {new Date(asmt.second_reminder_date).toLocaleDateString('en-GB', { day: 'numeric', month: 'short', year: 'numeric' })}
                            </option>
                            {/* only 2 reminder date needed */}
                            {/*
                            <option value={new Date(asmt.third_reminder_date).toLocaleDateString('en-GB', { day: 'numeric', month: 'short', year: 'numeric' })}>
                                {new Date(asmt.third_reminder_date).toLocaleDateString('en-GB', { day: 'numeric', month: 'short', year: 'numeric' })}
                            </option>
                            */}
                        </select>

                    )}

                    <div className="pointer-events-none absolute inset-y-0 right-0 flex items-center px-2 text-gray-700">
                        <svg className="fill-current h-4 w-4" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20">
                            <path d="M7 10l5 5 5-5H7z" />
                        </svg>
                    </div>
                </div>
            </div>

            <p className="text-center mb-4">Enter details of the participants:</p>

            <div className="flex flex-col lg:gap-4 w-full">
                {participants.map((participant, index) => (
                    <div key={index} className="flex  justify-evenly items-center lg:gap-4 gap-2 bg-red-100 p-4 rounded-lg">
                        <input
                            type="text"
                            name="first_name"
                            placeholder="First name"
                            value={participant.first_name}
                            onChange={(e) => handleInputChange(index, e)}
                            className="col-span-1 p-2 border rounded w-full" // Ensure full width
                        />
                        <input
                            type="text"
                            name="last_name"
                            placeholder="Last Name"
                            value={participant.last_name}
                            onChange={(e) => handleInputChange(index, e)}
                            className="col-span-1 p-2 border rounded w-full" // Ensure full width
                        />
                        <input
                            required
                            type="email"
                            name="user_name"
                            placeholder="Email"
                            value={participant.user_name}
                            onChange={(e) => handleInputChange(index, e)}
                            className="col-span-1 p-2 border rounded w-full" // Ensure full width
                        />
                        <select
                            name="relationship"
                            value={participant.relationship}
                            onChange={(e) => handleInputChange(index, e)}
                            className="col-span-1 p-2 border rounded w-full" // Ensure full width
                            required
                        >
                            <option value="">Select Relationship</option>
                            <option value="supervisor">Supervisor</option>
                            <option value="subordinate">Subordinate</option>
                            <option value="peer">Peer</option>
                            <option value="others">Others</option>
                            {/* <option value="self">Self</option> */}
                        </select>

                        {/* Show Remove button only for participants added after the first 4 */}
                        {index >= 4 && (
                            <button
                                onClick={() => removeParticipant(index)}
                                className="col-span-1 flex items-center justify-center text-red-500 bg-white border border-red-500 hover:bg-red-500 hover:text-white rounded p-2 w-[40px] lg:w-auto" // Make full width on small screens
                            >
                                <i className="fas fa-times"></i> {/* Font Awesome cross icon */}
                            </button>
                        )}
                    </div>
                ))}
            </div>

            <div className="text-center my-4">
                <button
                    onClick={addParticipant}
                    // className="bg-green-500 text-white px-4 py-2 rounded hover:bg-green-600"
                    className={`bg-green-500 text-white px-4 py-2 rounded ${participants.length >= 12 ? 'opacity-50 cursor-not-allowed' : 'hover:bg-green-600'}`}
                    disabled={participants.length >= 12}
                >
                    Add More Participants
                </button>
                {participants.length >= 12 && (
                    <p className="text-red-600 mt-2">Maximum number of participants added</p>
                )}
            </div>

            {
                error && (
                    <span className="block text-center text-red-600 bg-red-100 p-2 md:p-3 rounded-md text-sm md:text-base mt-2">
                        {error}
                    </span>
                )
            }

            <div className="mb-4">
                <label className="block mb-2 text-gray-700">
                    A note from you to the participants which we will send in the email. This will add a personal touch to your invitation (optional):
                </label>
                <textarea
                    onChange={(e) => setInvitationNote(e.target.value)}
                    placeholder="Add invitation note"
                    className="w-full p-2 border rounded h-32"
                ></textarea>
            </div>

            <div className="flex justify-center mb-4">
                <button
                    onClick={handleSubmit}
                    className={`bg-blue-600 text-white px-4 py-2 rounded ${submitting ? 'opacity-50 cursor-not-allowed' : ''}`}
                    disabled={submitting}
                >
                    {submitting ? 'Sending...' : 'Send Invitation and Start Questionnaire'}
                </button>
            </div>



        </div >
    );
};

export default Participants;
